import { Component, EventEmitter, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { TicketService } from 'src/app/shared/services/ticket.service';
import { validateCouponApi } from 'src/app/shared/constants/api.constants';
import { Channel } from 'src/app/shared/enums/channel';
import { Toast } from 'src/app/shared/enums/toast';
import { ICouponDiscount } from 'src/app/shared/models/ICoupon.model';
import { HelpersService, HttpBaseService, ToastService } from '@evento-ng/libs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-review-cart',
  templateUrl: './review-cart.component.html',
  styleUrls: ['./review-cart.component.scss'],
})
export class ReviewCartComponent {
  @Output() backToTickets = new EventEmitter();
  @Input() event;
  bookTicket$: Observable<any>;
  subTotal: number;
  quantity: number;
  vat: number;
  total: number;
  copoun: string;
  couponDiscount: ICouponDiscount;
  percentage: string;
  invoice: any;
  channel: string;
  showPage = true;
  isMobile = false;
  isSport = false;
  isSales = false;
  constructor(
    private ticketService: TicketService,
    public helpers: HelpersService,
    private dataService: HttpBaseService,
    public router: Router,
    private toast: ToastService,
    public translate: TranslateService,
    private spinner: NgxSpinnerService
  ) {
    if (this.router.url.includes('/sales/')) {
      this.isSales = true;
    }
    this.isSport = this.router.url.includes('sport');
  }

  ngOnInit(): void {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
    this.invoice = this.ticketService.bookTicket.getValue();
    this.calculation(this.invoice);

    // this.ticketService.bookTicket$.subscribe((invoice: any) => {
    //   this.calculation(invoice);
    //   this.invoice = invoice;
    // });
  }

  back() {
    this.backToTickets.emit();
  }

  TicketsToValidateCopoun(items) {
    let tickets = [];
    items.forEach((item) => {
      tickets.push({
        ticket: item.ticket.id,
        quantity: item.quantity,
      });
    });
    return tickets;
  }

  cancelCoupon() {
    this.couponDiscount = null;
    this.ticketService.updateBookTicket({
      promoCodeId: null,
      totalwithdiscount: null,
    });
    this.percentage = null;
    this.calculation(this.invoice);
  }

  validateCoupon(): void {
    const body = {
      event: this.event.id,
      items: this.TicketsToValidateCopoun(this.invoice.items),
      promoCode: this.copoun,
    };
    this.spinner.show();
    this.dataService.post(`${validateCouponApi}`, body).subscribe((res) => {
      this.spinner.hide();
      this.couponDiscount = res;

      this.ticketService.updateBookTicket({
        promoCodeId: this.couponDiscount.promoCodeId,
        totalwithdiscount: this.couponDiscount.total,
      });

      this.percentage = isNaN(
        (this.couponDiscount.discountAmount / this.subTotal) * 100
      )
        ? '0'
        : ((this.couponDiscount.discountAmount / this.subTotal) * 100).toFixed(
            2
          );
      this.total = this.couponDiscount.total;
      this.vat = this.couponDiscount.vat;
      this.subTotal = this.couponDiscount.subTotal;
      if (!this.couponDiscount.promoCodeApplied) {
        this.toast.show(
          'Error',
          this.translate.currentLang == 'ar'
            ? 'لم يتم تفعيل الكوبون'
            : 'Coupon Not Applied',
          {
            classname: Toast.error,
          }
        );
      } else {
      }
    });
  }

  private calculation(schedule: any): void {
    this.subTotal = schedule?.items
      .map((item) => Math.round(item.quantity * item.ticket.price * 100) / 100)
      .reduce((a, b) => a + b, 0);
    this.quantity = schedule?.items
      .map((item) => item.quantity)
      .reduce((a, b) => a + b, 0);

    this.vat = (this.subTotal * 0.15 * 100) / 100;
    this.total = this.subTotal * 1.15;
    if (this.total == 0) {
      this.ticketService.updateBookTicket({
        channel: Channel.online,
        payOption: 'free',
      });
    }
  }

  showReview(ev) {
    this.showPage = !ev;
  }

  BackPaymentMobile() {
    this.showPage = true;
  }
}
